/**
 * Corrige nomes/textos PT-BR com encoding quebrado:
 * - mojibake Latin-1/UTF-8 (ex.: "GonÃ§alves" → "Gonçalves")
 * - caractere de substituição U+FFFD (ex.: "GON�ALVES" → "GONÇALVES")
 * quando o byte original já foi perdido no banco.
 */
function tryFixLatin1AsUtf8(str) {
  if (!/[ÃÂÐÑ]/.test(str)) {
    return str;
  }
  try {
    const bytes = Uint8Array.from(str, (c) => c.charCodeAt(0) & 0xff);
    const repaired = new TextDecoder("utf-8").decode(bytes);
    if (repaired && !repaired.includes("\uFFFD") && repaired !== str) {
      return repaired;
    }
  } catch (e) {
    // ignore
  }
  return str;
}

function fixReplacementCharPortuguese(str) {
  if (!str.includes("\uFFFD")) {
    return str;
  }

  let s = str;

  // Assunção / Conceição: dois bytes perdidos antes de "o"
  s = s.replace(/\uFFFD\uFFFD([Oo])/g, "çã$1");

  // José / JOSÉ
  s = s.replace(/([Jj])([Oo])([Ss])\uFFFD(?=\s|$|,|\.)/g, (_, j, o, ss) => {
    const e = j === "J" && o === "O" && ss === "S" ? "É" : "é";
    return j + o + ss + e;
  });

  // Sá no fim de palavra
  s = s.replace(/S\uFFFD(?=\s|$|,|\.)/g, "Sá");
  s = s.replace(/s\uFFFD(?=\s|$|,|\.)/g, "sá");

  // ão após consoante (Perdigão, etc.) — não aplicar em N (Lourenço = nço)
  s = s.replace(/([BbCcDdFfGgPpTtVvXxZz])\uFFFD([Oo])/g, (_, c, o) => {
    const tilde = c === c.toUpperCase() ? "Ã" : "ã";
    return c + tilde + o;
  });

  // ç antes de a/o/u (Gonçalves, Lourenço, França, Mendonça)
  s = s.replace(/([NnMmFf])\uFFFD([AaOoUu])/g, (_, c, v) => {
    const cedilla = c === c.toUpperCase() ? "Ç" : "ç";
    return c + cedilla + v;
  });

  // restante: � + vogal → ç + vogal (maiúsculo se o contexto for UPPER)
  s = s.replace(/([A-ZÁÉÍÓÚÂÊÔÃÕ])\uFFFD([AEIOUaeiouÁÉÍÓÚáéíóú])/g, (_, prev, v) => {
    return prev + "Ç" + v.toUpperCase();
  });
  s = s.replace(/\uFFFD([AaEeIiOoUu])/g, "ç$1");

  return s;
}

export function fixPortugueseText(value) {
  if (value == null || value === "") {
    return "";
  }
  if (typeof value !== "string") {
    return value;
  }
  return fixReplacementCharPortuguese(tryFixLatin1AsUtf8(value));
}
